// extracted by mini-css-extract-plugin
var _1 = "lroym__menu";
export { _1 as "menu" }
